import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { signIn, resetPassword, signUp, signOut } from 'aws-amplify/auth';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { FeedBackModel } from 'src/app/models/feedback.model';

import { ActiveService } from '../../active-service';
import { OrgTypesModel } from '../models/org-types.model';
import { PinLoginModel } from '../models/pin-login.model';

import { OrgModel } from './../../models/org.model';

@Injectable()
export class AuthService extends ActiveService {
    constructor(
        public http: HttpClient,
        public store: Store
    ) {
        super(http, store);
    }

    mainLogin(obj): Observable<any> {
        return this.post('users/login', obj).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.models.form;
            })
        );
    }

    loginWithCognito(obj): Promise<any> {
        return signIn({ username: obj.email, password: obj.password })
            .then(async (resp) => {
                if (obj.remember) {
                    try {
                        //TODO: As not needed for now already handled by aws team in cognito
                        // const result = await Auth.rememberDevice();
                    } catch (error) {
                        console.log('Error remembering device', error);
                    }
                }
                return resp;
            })
            .catch((error) => {
                throw error;
            });
    }

    pinLogin(obj): Observable<any> {
        return this.post('staff/login', obj).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.message;
            })
        );
    }

    staffMe(): Observable<any> {
        return this.get('staff/me').pipe(
            map((resp) => {
                return new PinLoginModel(resp.models.staff);
            }),
            catchError((error) => {
                throw error.error.message;
            })
        );
    }

    signUp(obj): Observable<any> {
        return this.post('users/signup', obj).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.models.member;
            })
        );
    }

    signUpWithCognito(obj): Promise<any> {
        const attributes = {
            family_name: obj.basicInfo.family_name,
            given_name: obj.basicInfo.given_name,
            phone_number: obj.basicInfo.contact_number,
        };
        return signUp({
            username: obj.accountInfo.email,
            password: obj.accountInfo.password,
            options: {
                userAttributes: attributes,
            },
        });
    }

    forgot(obj): Observable<any> {
        return this.post('users/forgotpassword', obj).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.models.form;
            })
        );
    }

    forgotWithCognito(obj): Promise<any> {
        return resetPassword({ username: obj.email });
    }

    logoutWithCognito() {
        window.localStorage.setItem('userData', '');
        return signOut();
    }

    forgotPin(obj): Observable<any> {
        return this.put('staff/forgotpin', obj).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.models.staff;
            })
        );
    }

    reset(obj): Observable<any> {
        return this.post('users/resetpassword', obj).pipe(
            map((resp) => {
                return resp.models;
            }),
            catchError((error) => {
                throw error.error.models.form;
            })
        );
    }

    orgTypes(): Observable<any> {
        return this.get('organization-types').pipe(
            map((resp) => {
                return resp.models.organizationtype.map((item) => new OrgTypesModel(item));
            })
        );
    }

    feedBack(obj): Observable<FeedBackModel> {
        return this.post('feedbacks', obj).pipe(
            map((resp) => {
                return resp.models.feedback;
            }),
            catchError((error) => {
                throw error.error.models.feedback;
            })
        );
    }

    createOrg(obj): Observable<OrgModel> {
        return this.post('organizations', obj).pipe(
            map((resp) => {
                return resp.models.organization;
            }),
            catchError((error) => {
                throw error.error.models.organization;
            })
        );
    }
}
